// https://docs.microsoft.com/en-us/previous-versions/office/sharepoint-visio/jj245640(v=office.15)

const FIELD_TYPE_ATTACHMENTS = 19;
const FIELD_TYPE_BOOLEAN = 8;
const FIELD_TYPE_CHOICE = 6;
const FIELD_TYPE_DATETIME = 4;
const FIELD_TYPE_LOOKUP = 7;
const FIELD_TYPE_MULTICHOICE = 15;
const FIELD_TYPE_URL = 11;
const FIELD_TYPE_USER = 20;

export {
    FIELD_TYPE_ATTACHMENTS,
    FIELD_TYPE_BOOLEAN,
    FIELD_TYPE_CHOICE,
    FIELD_TYPE_DATETIME,
    FIELD_TYPE_LOOKUP,
    FIELD_TYPE_MULTICHOICE,
    FIELD_TYPE_URL,
    FIELD_TYPE_USER,
};